import styled from "@emotion/styled";
import React, { useContext } from "react";
import { FaGoogle, FaApple } from "react-icons/fa6";
import LoginAvantiButton from "../LoginAvantiPopup/LoginAvantiButton";

const SocialLogin = (props) => {
  const { userHelper, navigate, location, dataHelper, popup, message } = props;

  const googleLogin = async () => {
    let result = await userHelper.googleLogin();
    callbackLogin(result, "Google");
  };

  const appleLogin = async () => {
    let result = await userHelper.appleLogin();
    callbackLogin(result, "Apple");
  };

  const callbackLogin = (result, socialType) => {
    if (result.success) {
      if (result.isNewUser) {
        let firstName;
        let lastName;
        let aName =
          result?.signInResult?.user?.providerData[0]?.displayName?.split(" ");
        if (aName) {
          lastName = aName.pop();
          firstName = aName.join(" ");
        }

        let signUpParams = {
          email: result?.signInResult?.user?.providerData[0]?.email,
          firstName,
          lastName,
          socialType,
          socialData: {
            accessToken: result?.signInResult?.user?.accessToken,
          },
        };

        navigate("/cadastro", { state: signUpParams });
      } else {
        if (result.needsLinking) {
          window.location.href = "/";

          /* -- 2024-06-27 -- Por hora não vamos fazer a conexão até implementarmos no app.
          history.replace(routes.linkLogin.path,{
            // email: result.user.providerData[0].email,
            resultUser: {
              operationType: result.signInResult.operationType,
              providerId: result.signInResult.providerId,
              user: {
                accessToken: result.signInResult.user?.accessToken,
                displayName: result.signInResult.user?.displayName,
                providerId: result.signInResult.user?.providerId,
                providerData: result.signInResult.user?.providerData,
              }
            },
          });
          */
        } else {
          window.location.href = "/";
        }
      }
    }
  };

  return (
    <StyledSocialLogin>
      <div className={"social-separator"}>
        <div className={"social-separator-line"} />
        <span typo="paragraph-xl" className={"social-separator-label"}>
          ou
        </span>
      </div>
      <div className={"social-list"}>
        <div className={"social-list-links"}>
          <LoginAvantiButton
            className={"social-list-link avanti"}
            popup={popup}
            message={message}
            {...props}
          />
          <a onClick={appleLogin} className={"social-list-link apple"}>
            <div className="icon-container">
              <FaApple size={24} color="#ffffff" />
            </div>
            <div className="txt-container">
              <span className="social-txt">Login com Apple</span>
            </div>
            <div className="icon-container" />
          </a>
          {/*
        <a onClick={facebookLogin} className={'social-list-link facebook'}>
          <FaFacebookF size={24} color="#ffffff"  />
        </a>
        */}
          <a onClick={googleLogin} className={"social-list-link google"}>
            <div className="icon-container">
              <FaGoogle size={24} color="#404040" />
            </div>
            <div className="txt-container">
              <span className="social-txt">Login com Google</span>
            </div>
            <div className="icon-container" />
          </a>
        </div>
      </div>
    </StyledSocialLogin>
  );
};

export default SocialLogin;

/* style */

const StyledSocialLogin = styled.div`
  width: 500px;

  @media (max-width: 768px) {
    width: 100vw;
    max-width: 500px;
  }
  @media (max-width: 600px) {
    padding: 0 16px;
    max-width: 600px;
  }

  .social-separator {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .social-separator-line {
      position: absolute;
      top: 0.5em;
      width: 100%;
      height: 1px;
      /* background: ${(props) => props.config?.themeLayout?.subtext}; */
      opacity: 0.3;
    }

    .social-separator-label {
      font-family: "Roboto";
      position: relative;
      color: #8c8c8c;
      padding: 0 10px;
    }
  }

  &.mobile {
    .social-list {
      margin-top: 24px;
    }
  }

  .social-list {
    margin-top: 48px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;

    .social-list-title {
      display: flex;
      align-items: center;
      padding-right: 20px;
      /* color: ${(props) => props.config?.themeLayout?.text}; */
    }

    .social-list-links {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 16px;
      width: 100%;

      .social-list-link {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 48px;
        border-radius: 4px;
        cursor: pointer;

        .icon-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30%;
        }

        .txt-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 70%;

          .social-txt {
            font-family: "Roboto";
            font-size: 14px;
            line-height: 21px;
            font-weight: 500;
          }
        }

        &.avanti {
          background-color: #006e3d;
          color: #ffffff;
        }
        &.apple {
          background-color: #000000;
          color: #ffffff;
        }

        &.facebook {
          background-color: #2c59b1;
        }

        &.google {
          background-color: #ffffff;
          border: 1px solid #e6e6e6;
          color: #404040;
        }

        .social-list-logo {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
`;
